import { SceneSetters } from "../../types";
import { addCard, setupDrag } from "./helpers/cardHelper";
import { PLAYER_FRAME, defaultStats, TILE_WIDTH } from "../../data/settings";
import { wiggle } from "./helpers/tweenHelper";

const sceneConfig: Phaser.Types.Scenes.SettingsConfig = {
  active: false,
  visible: false,
  key: "Title",
};

export default class TitleScene extends Phaser.Scene {
  private setter: SceneSetters;

  constructor(setter: SceneSetters) {
    super(sceneConfig);
    this.setter = setter;
  }

  public preload() {
    this.load.atlas(
      "atlas",
      `${process.env.PUBLIC_URL}/spritesheet.png`,
      `${process.env.PUBLIC_URL}/spritesheet.json`
    );
    const [x, y, w, h] = [TILE_WIDTH, (3 / 2) * TILE_WIDTH, TILE_WIDTH * 3, 30];
    // center-left origin because this bar grows to the right
    const progressBar = this.add.rectangle(x, y, 0, h).setFillStyle(0xffffff, 1).setOrigin(0, 0.5);
    // prettier-ignore
    const progressBox = this.add.rectangle(x - 10, y, w + 20, h + 20).setFillStyle(0x222222, 0.8).setOrigin(0, 0.5);

    this.load.on("progress", (value: number) => {
      progressBar.width = TILE_WIDTH * 3 * value;
    });
    this.load.on("complete", () => {
      progressBar.destroy();
      progressBox.destroy();
    });
  }

  public create() {
    const sprite = addCard(this, PLAYER_FRAME, 1, 1, defaultStats).setDepth(1);
    wiggle(this, sprite);
    const reward = addCard(this, "rewards/campfire", 3, 1);
    setupDrag(this, sprite, (gameObject, endPoint, initialPoint) => {
      const [x, y] = endPoint;
      const overlapsReward = reward.x === x && reward.y === y;
      if (overlapsReward) this.goToNextScene();
      [gameObject.x, gameObject.y] = initialPoint;
    });
  }

  private goToNextScene() {
    this.setter.setScreen("Game");
    this.scene.switch("Game");
  }
}
